<template>
  <div />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage.vue'

export default {
  name: 'AbstractThankYouPage',

  extends: AbstractPage,

  /**
   * @returns {{companies: *[]}}
   */
  data() {
    return {
      companies: [],
    }
  },

  /**
   *
   */
  beforeMount() {
    this.companies = this.$store.getters['lead/getResult']('companies', [])
  },
}
</script>
